<template>
  <section
    :class="[
      'gift-card-wrapper',
      'flex-col-center',
      awardNumberClass,
      displayLayout,
      cardType,
      hasBgColor ? 'hasBg' : 'noBg',
      fissionStyleGame,
      showScore ? 'has-padding-top' : 'no-padding-top',
    ]"
  >
    <!-- <card-in-row
      v-if="fissionGame === 'mobile-legends'"
      :type="type"
      :cardType="cardType"
      :dataSource="datas"
      :displayMode="displayMode"
      :className="className"
    /> -->

    <card-in-column
      :type="type"
      :cardType="cardType"
      :dataSource="datas"
      :displayMode="displayMode"
      @className="getClassName"
    />

    <!-- 分享按钮 -->
    <share-btn
      :btnText="$t('fission.share-one')"
      tipsLeft="50%"
      :type="type"
      @click-share="clickShare"
      :class="['share-btn-wrapper', fissionStyleGame]"
      :tipsText="tipsText"
      :activityId="activityId"
      v-if="showShareBtn"
      :firstShareStatus="firstShareStatus"
      hasTips
    />
  </section>
</template>
<script>
  import { ShareBtn } from '../CommonBtns/index.js'
  import { getCouponList } from '@/api/fission'
  import { mapState, mapGetters } from 'vuex'
  import { normalizeFissionStyleGame } from '../../configData'

  export default {
    components: {
      ShareBtn,
      // CardInRow: () => import('./AwardCard/cardInRow.vue'),
      CardInColumn: () => import('./AwardCard/cardInColumn.vue'),
    },
    props: {
      dataSource: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
      activityId: {
        type: String,
        default: '',
      },
      userPoints: {
        type: Object,
        default: () => {},
      },
      showShareBtn: {
        type: Boolean,
        default: false,
      },
      hasBgColor: {
        type: Boolean,
        default: true,
      },
      cardType: {
        type: String,
        default: 'page',
      },
      showLoginBtn: {
        type: Boolean,
        default: false,
      },
      displayMode: {
        type: String,
        default: '',
      },
      firstShareStatus: {
        type: Boolean,
        default: false,
      },
      showScore: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showPopover: true,
        couponInfos: {},
        tipsText: '',
        discountMoney: '', // 优惠金额
        loginStatus: false,
        awardsContainCoupon: false, //标记奖品是否包含优惠券
        awardNumberClass: '',
      }
    },
    computed: {
      ...mapState(['region', 'fissionGame']),
      ...mapGetters(['displayLayout']),
      fissionStyleGame() {
        return normalizeFissionStyleGame(this.fissionGame)
      },
      className() {
        const clsName = {
          1: 'only-one',
          2: 'only-two',
          3: 'only-three',
        }
        const { datas = [] } = this || {}
        // TODO: 3 个以上的也与三个相同的样式
        const res = datas.length > 3 ? 'only-three' : clsName[datas.length]
        return res
      },
      datas() {
        const { dataSource = [] } = this || {}
        let paymentFinishedInfos = null
        let paymentInfos = null
        // conditionType 1：初始奖励 2：首次分享奖励 3：新用户注册奖励 4：新用户付费奖励 5：新用户付费封顶奖励
        return dataSource
          .filter((item) => [3, 4, 5].includes(item.conditionType * 1))
          .map((node) => {
            if (!node) return
            // TODO: PUBGM 没有商品奖励，但是要考虑以后有其它游戏的商品奖励，需要兼容处理
            const iconMap = {
              3: 'coupon',
              4: 'gift',
              5: 'kgold',
            }
            if (this.cardType === 'page') {
              iconMap[4] = 'score-icon'
            }
            node.icon = require(`@/assets/images/activities/fission/icon/${
              iconMap[node.awardType]
            }.png`)
            if (node.conditionType * 1 === 5) {
              paymentFinishedInfos = node
            }
            if (node.conditionType * 1 === 4) {
              paymentInfos = node
            }
            if (node.awardType * 1 === 3) {
              this.awardsContainCoupon = true
              // TODO: mlbb 获取到优惠券奖励该如何展示，目前只有商品奖励的样式
              // 处理优惠券数据
              const { couponType, couponPrice, couponDiscount } = node
              // 1 立减券 2折扣券
              if (couponType * 1 === 1) {
                node.awardCount = couponPrice // 展示的金额
              }
              if (couponType * 1 === 2) {
                node.awardCount = 100 - couponDiscount * 1 //展示的折扣
              }
            }
            return node
          })
          .map((list) => {
            // 设置limited
            if (list.conditionType * 1 === 3 || list.conditionType * 1 === 5) {
              list.limited = 1
            }
            const { conditionCount: finishedCount } = paymentFinishedInfos || {}
            const { conditionCount = 1 } = paymentInfos || {}
            if (list.conditionType * 1 === 4) {
              list.limited = Math.floor(finishedCount / conditionCount)
            }
            return list
          })
          .slice() // TODO: 临时调试展示数量，记得删除
      },
      displayVertical() {
        // 数据超过3条或者存在优惠券的条件下则竖直排列
        return this.datas.length > 3 || this.awardsContainCoupon
      },
    },
    watch: {
      userPoints() {
        this.getTipsText()
      },
    },
    methods: {
      clickShare() {
        this.$emit('click-share')
      },
      getTipsText() {
        // 用户是否已首次分享： 1：未首次分享。 2：已首次分享
        const { shareStatus } = this.userPoints || {}
        // 首次分享奖励优惠券
        const couponInfos =
          (this.dataSource.filter(
            (item) => item.conditionType * 1 === 2 && item.awardType * 1 === 3
          ) || [])[0] || {}
        // 首次分享奖励游戏商品
        const pointInfos =
          (this.dataSource.filter(
            (item) => item.conditionType * 1 === 2 && item.awardType * 1 === 4
          ) || [])[0] || {}
        // 完成首次分享获取优惠券信息
        if (shareStatus * 1 === 2 && couponInfos.couponId) {
          this.getCouponInfos(couponInfos.couponId)
        }
        if (pointInfos.conditionType) {
          // this.$emit('share-reward', 'point')
        }
      },
      getCouponInfos(couponId) {
        getCouponList({
          country: this.region,
          couponIdString: couponId,
        }).then((res) => {
          if (res && res.length) {
            const couponInfos = res[0] || {}
            this.couponInfos = couponInfos
            const { couponType, couponPrice, couponDiscount } = couponInfos
            // 1 立减券 2折扣券
            if (couponType * 1 === 1) {
              this.discountMoney = couponPrice
            }
            if (couponType * 1 === 2) {
              this.discountMoney = 100 - couponDiscount * 1
            }
            this.tipsText = `${couponType}: ${this.discountMoney}`
            // this.$emit('share-reward', 'coupon')
          }
        })
      },
      getClassName(res) {
        this.awardNumberClass = res
        this.$emit('className', res)
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
